import React from 'react';
import { CTAButton } from './CTAButton';
interface TransformCTAProps {
  headline: string;
  label?: string;
  tone?: 'dark' | 'light';
  id?: string;
}
export function TransformCTA({
  headline,
  label = 'I WANT MY CLINICAL ROUTE NOW',
  tone = 'dark',
  id
}: TransformCTAProps) {
  const isDark = tone === 'dark';
  return <div className="mx-auto mt-10 w-full max-w-md" data-id="element-235" data-mp="2uvuz0agb8lau">
      <p className={`mb-4 text-center font-display text-[19px] font-bold leading-snug sm:text-2xl ${isDark ? 'text-white' : 'text-ink-900'}`} data-id="element-236" data-mp="274pli1xue53p">
        {headline}
      </p>
      <CTAButton id={id} label={label} data-id="element-237" data-mp="2h2vj47cm8p2r" />
      <p className={`mt-3 text-center text-[11px] font-medium leading-relaxed sm:text-xs ${isDark ? 'text-white/50' : 'text-ink-900/55'}`} data-id="element-238" data-mp="2h4q7xwr0d1c4">
        One-time payment · Lifetime access · 7-day guarantee
      </p>
    </div>;
}